import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth-guard';
import { roleGuard } from './core/guards/role-guard';
import { nonPinLoginGuard } from './core/guards/non-pin-login.guard';
import { MainLayout } from './layouts/main-layout/main-layout';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then(m => m.Login)
  },
  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard],
    children: [
      {
        path: 'home',
        loadComponent: () => import('./pages/home/home').then(m => m.Home),
        canActivate: [nonPinLoginGuard]
      },
      {
        path: 'incidencias',
        loadComponent: () => import('./pages/incidencias/incidencias').then(m => m.Incidencias),
        canActivate: [roleGuard, nonPinLoginGuard],
        data: { permission: 'incidencias.view' }
      },
      {
        path: 'subir-evidencia',
        loadComponent: () => import('./pages/subir-evidencia/subir-evidencia').then(m => m.SubirEvidencia),
        canActivate: [roleGuard]
      },
      {
        path: 'cargar-tarjetas',
        loadComponent: () => import('./pages/cargar-tarjetas/cargar-tarjetas').then(m => m.CargarTarjetas),
        canActivate: [roleGuard]
      },
      {
        path: 'tecnicos',
        loadComponent: () => import('./pages/tecnicos/tecnicos').then(m => m.Tecnicos),
        canActivate: [roleGuard, nonPinLoginGuard],
        data: { permission: 'incidencias.view' }
      },
      {
        path: 'telefonos',
        loadComponent: () => import('./pages/telefonos/telefonos').then(m => m.Telefonos),
        canActivate: [roleGuard, nonPinLoginGuard],
        data: { permission: 'incidencias.view' }
      },
      {
        path: 'catalogos',
        canActivate: [roleGuard, nonPinLoginGuard],
        data: { roles: [5] },
        children: [
          {
            path: 'usuarios',
            loadComponent: () => import('./pages/catalogos/catalogos-usuarios').then(m => m.CatalogosUsuarios),
          },
          {
            path: 'telefonos',
            loadComponent: () => import('./pages/catalogos/catalogos-telefonos').then(m => m.CatalogosTelefonos),
          },
          {
            path: 'fallas-soluciones',
            loadComponent: () => import('./pages/catalogos/catalogos-fallas').then(m => m.CatalogosFallas),
          },
          {
            path: 'equipos',
            loadComponent: () => import('./pages/catalogos/catalogos-equipos').then(m => m.CatalogosEquipos),
          },
          {
            path: 'tipos-equipo',
            loadComponent: () => import('./pages/catalogos/catalogos-tipos-equipo').then(m => m.CatalogosTiposEquipo),
          },
        ]
      },
      { path: '**', redirectTo: 'home' },
    ],
  },
];
